module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/amwayterms/css/fonts/notosanskr/notokr-regular.woff2
// module id = Sk4J
// module chunks = 0